var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCompleted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 70,
    viewBox: "0 0 86 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.4895 35.8616C72.4895 52.4013 59.2863 65.8088 43.0001 65.8088C26.7139 65.8088 13.5107 52.4013 13.5107 35.8616C13.5107 19.322 26.7139 5.91394 43.0001 5.91394C59.2863 5.91394 72.4895 19.322 72.4895 35.8616Z",
    stroke: "#52AE30",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M9.04248 35.8619C9.04248 24.6613 14.3005 14.7079 22.4467 8.4086M42.9999 1.37683C38.4112 1.37683 34.0352 2.30112 30.0425 3.97628L42.9999 1.37683Z",
    stroke: "#52AE30",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.1705 38.584C75.1705 55.1237 61.9673 68.5311 45.6811 68.5311C29.3949 68.5311 16.1917 55.1237 16.1917 38.584C16.1917 22.0444 29.3949 8.63641 45.6811 8.63641C61.9673 8.63641 75.1705 22.0444 75.1705 38.584ZM57.5358 28.1684C57.8968 27.8265 57.9165 27.2522 57.5796 26.8857C57.2427 26.5194 56.677 26.4996 56.316 26.8416L37.3999 44.7718L31.494 38.7742C31.1455 38.4198 30.5789 38.4198 30.2304 38.7742C29.881 39.1287 29.881 39.7034 30.2304 40.0573L36.7467 46.6748C37.0871 47.0206 37.6358 47.0306 37.9879 46.6966L57.5358 28.1684Z",
    fill: "#52AE30",
    fillOpacity: 0.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0324 26.5978L36.4845 45.1262L29.9683 38.5088",
    stroke: "#52AE30",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.149 6.82141C71.8889 6.82141 72.4894 6.21196 72.4894 5.46023C72.4894 4.7085 71.8889 4.09906 71.149 4.09906C70.4091 4.09906 69.8086 4.7085 69.8086 5.46023C69.8086 6.21196 70.4091 6.82141 71.149 6.82141Z",
    stroke: "#52AE30"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.8299 63.0873C74.5698 63.0873 75.1703 62.4782 75.1703 61.7257C75.1703 60.9741 74.5698 60.3641 73.8299 60.3641C73.09 60.3641 72.4895 60.9741 72.4895 61.7257C72.4895 62.4782 73.09 63.0873 73.8299 63.0873Z",
    fill: "#52AE30"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M76.064 14.0809H78.7448",
    stroke: "#52AE30",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M82.3191 14.0809H84.9999",
    stroke: "#52AE30",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M80.532 15.8957V18.6181",
    stroke: "#52AE30",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M80.532 12.266V9.54358",
    stroke: "#52AE30",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1 62.1791H5.46809",
    stroke: "#52AE30",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M9.04248 62.1791H13.5106",
    stroke: "#52AE30",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M7.25488 63.9939V68.5312",
    stroke: "#52AE30",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M7.25488 60.3638V55.8266",
    stroke: "#52AE30",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCompleted);
export default __webpack_public_path__ + "static/media/icon-completed.e32c44be46922b0ce8c977db1207a6b5.svg";
export { ForwardRef as ReactComponent };